export default __webpack_public_path__ + "static/media/menCoatTrousers.e5f697fb.png";